import * as React from "react"

/**
 * When a Popover (e.g. MultiPick dropdown) is rendered inside a Dialog,
 * Radix Dialog's RemoveScroll blocks scroll on portalled content that lives
 * outside the dialog in the DOM. Providing the dialog content ref here
 * allows the Popover to portal *into* the dialog so scrolling works.
 */
export const PopoverPortalContainerContext = React.createContext<HTMLElement | null>(null)

export function usePopoverPortalContainer(): HTMLElement | null {
  return React.useContext(PopoverPortalContainerContext)
}
